import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ClientsComponent } from './clients/clients.component';
import { CountryComponent } from './country/country.component';
import { ZoneComponent } from './zone/zone.component';
import { StateComponent } from './state/state.component';
import { DistrictComponent } from './district/district.component';
import { LeadStatusComponent } from './lead-status/lead-status.component';
import { ProductCategoryComponent } from './product-category/product-category.component';
import { RoleComponent } from './role/role.component';
import { AgeGroupComponent } from './age-group/age-group.component';
import { LeadTypeComponent } from './lead-type/lead-type.component';
import { LeadStageComponent } from './lead-stage/lead-stage.component';
import { LeadSourceComponent } from './lead-source/lead-source.component';
import { ProductColorComponent } from './product-color/product-color.component';
import { OccupationComponent } from './occupation/occupation.component';
import { CustomerTypeComponent } from './customer-type/customer-type.component';
import { VirtualNumberComponent } from './virtual-number/virtual-number.component';
import { FollowupReasonComponent } from './followup-reason/followup-reason.component';
import { JunkReasonComponent } from './junk-reason/junk-reason.component';
import { NoResponseReasonComponent } from './no-response-reason/no-response-reason.component';
import { PreSalesLostReasonComponent } from './pre-sales-lost-reason/pre-sales-lost-reason.component';
import { SalesLostReasonComponent } from './sales-lost-reason/sales-lost-reason.component';
import { ProductModelComponent } from './product-model/product-model.component';
import { ProductVarientComponent } from './product-varient/product-varient.component';
import { LeadSubSourceComponent } from './lead-sub-source/lead-sub-source.component';
import { LicenseCodeComponent } from './license-code/license-code.component';
import { AreaComponent } from './area/area.component';
import { RegionComponent } from './region/region.component';
import { LocationComponent } from './location/location.component';
import { ParentDealerComponent } from './parent-dealer/parent-dealer.component';
import { OutletComponent } from './outlet/outlet.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LevelMasterComponent } from './level-master/level-master.component';
import { LikehoodToPurchaseMasterComponent } from './likehood-to-purchase-master/likehood-to-purchase-master.component';
import { CustomerRequirementComponent } from './customer-requirement/customer-requirement.component';
import { LeadPriorityComponent } from './lead-priority/lead-priority.component';
import { DeliveryPreferenceComponent } from './delivery-preference/delivery-preference.component';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { CustomerInterestComponent } from './customer-interest/customer-interest.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { VNMappingComponent } from './vn-mapping/vn-mapping.component';
import { MatSelectModule } from '@angular/material/select';
import { MsPinComponent } from './ms-pin/ms-pin.component';
import { CustomerTitleComponent } from './customer-title/customer-title.component';
import { ModeOfContactComponent } from './mode-of-contact/mode-of-contact.component';
import { SalesFollowReasonComponent } from './sales-follow-reason/sales-follow-reason.component';
import { PostponedReasonComponent } from './postponed-reason/postponed-reason.component';
import { FileTypeComponent } from './file-type/file-type.component';
import { ReportsComponent } from './reports/reports.component';
import { SubReasonComponent } from './sub-reason/sub-reason.component';
import { ProductLostReasonComponent } from './product-lost-reason/product-lost-reason.component';
import { ProductLostSubReasonComponent } from './product-lost-sub-reason/product-lost-sub-reason.component';
import { ServiceAdvisorComponent } from './service-advisor/service-advisor.component';
import { FollowUpStatusComponent } from './follow-up-status/follow-up-status.component';
import { OemCompetitorComponent } from './oem-competitor/oem-competitor.component';
import { LostModelComponent } from './lost-model/lost-model.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { CustomerFeedbackComponent } from './customer-feedback/customer-feedback.component';
import { CorporateComponent } from './corporate/corporate.component';
import { CommunicateToComponent } from './communicate-to/communicate-to.component';
import { CustomerFollowupComponent } from './customer-followup/customer-followup.component';
import { CustomerCategoryComponent } from './customer-category/customer-category.component';
import { GenderComponent } from './gender/gender.component';
import { ImportUserComponent } from './import-user/import-user.component';
import { TermsComponent } from './terms/terms.component';
import { VnMappingImportComponent } from './vn-mapping-import/vn-mapping-import.component';
import { UsersComponent } from './users/users.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UserEditPopupComponent } from './userEditPopup/userEditPopup.component';
import { UsersUploadComponent } from './users-upload/users-upload.component';
import { NonSalesCategoryComponent } from './non-sales-category/non-sales-category.component';
import { PriceComponent } from './price/price.component';

@NgModule({
  declarations: [
    ClientsComponent,
    CountryComponent,
    ZoneComponent,
    StateComponent,
    DistrictComponent,
    LeadStatusComponent,
    ProductCategoryComponent,
    RoleComponent,
    AgeGroupComponent,
    LeadTypeComponent,
    LeadStageComponent,
    LeadSourceComponent,
    ProductColorComponent,
    OccupationComponent,
    CustomerTypeComponent,
    VirtualNumberComponent,
    FollowupReasonComponent,
    JunkReasonComponent,
    NoResponseReasonComponent,
    JunkReasonComponent,
    PreSalesLostReasonComponent,
    SalesLostReasonComponent,
    ProductModelComponent,
    ProductVarientComponent,
    LeadSubSourceComponent,
    LicenseCodeComponent,
    AreaComponent,
    RegionComponent,
    LocationComponent,
    ParentDealerComponent,
    OutletComponent,
    ChangePasswordComponent,
    UserProfileComponent,
    LevelMasterComponent,
    LikehoodToPurchaseMasterComponent,
    CustomerRequirementComponent,
    LeadPriorityComponent,
    DeliveryPreferenceComponent,
    PaymentMethodComponent,
    CustomerInterestComponent,
    PageNotFoundComponent,
    VNMappingComponent,
    MsPinComponent,
    CustomerTitleComponent,
    ModeOfContactComponent,
    SalesFollowReasonComponent,
    PostponedReasonComponent,
    FileTypeComponent,
    ReportsComponent,
    SubReasonComponent,
    ProductLostReasonComponent,
    ProductLostSubReasonComponent,
    ServiceAdvisorComponent,
    FollowUpStatusComponent,
    OemCompetitorComponent,
    LostModelComponent,
    ChecklistComponent,
    CustomerFeedbackComponent,
    CorporateComponent,
    CommunicateToComponent,
    CustomerFollowupComponent,
    CustomerCategoryComponent,
    GenderComponent,
    ImportUserComponent,
    TermsComponent,
    VnMappingImportComponent,
    UsersComponent,
    UserEditPopupComponent,
    UsersUploadComponent,
    NonSalesCategoryComponent,
    PriceComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CoreRoutingModule,
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonModule,
    MatDialogModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatTabsModule,
    MatSelectModule,
    NgSelectComponent,
    NgMultiSelectDropDownModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
})
export class CoreModule {}
